import React from 'react';
import ClearReportsHistoryButton from './clearReportsHistoryButton'

import styles from './reportsHistoryControls.module.scss'

const ReportsHistoryControls = () => {
  return (
    <div className={styles.reportsHistoryControls}>
      <div className={styles.container_control}>
        <ClearReportsHistoryButton />
      </div>
    </div>
  )
}

export default React.memo(ReportsHistoryControls)